export const PAGE_NAME = {
  CONTACT_US: "contact_us",
  REQUEST_QUOTE: "request_quote",
};
